import React, { memo, useCallback, useMemo } from 'react'
import type { ComposedInvoice, PendingInvoiceAction } from 'src/interfaces/invoice'
import { InvoiceActionVerb } from 'src/constants/invoice/enums'
import { buildInvoiceLabels, getComposedInvoiceLabel } from 'src/utils/invoiceLabels'
import { getAvailableComposedInvoiceActions, getTargetInvoiceIds } from 'src/utils/invoiceActions'
import { InvoiceActionsMenu } from './InvoiceActionsMenu'

interface Props {
  invoice: ComposedInvoice
  onRunAction(action: PendingInvoiceAction): void
}

const ComposedInvoiceActionsCellComponent = ({ invoice, onRunAction }: Props) => {
  const verbs = useMemo(() => {
    return getAvailableComposedInvoiceActions(invoice)
  }, [invoice])

  // Hands a pending action up to the page; it never dispatches. The confirm modal is the only
  // thing that dispatches, so no money action can start without passing through it.
  const handleSelect = useCallback(
    (verb: InvoiceActionVerb) => {
      onRunAction({
        verb,
        invoiceIds: getTargetInvoiceIds(invoice, verb),
        composedInvoiceLabel: getComposedInvoiceLabel(invoice),
        invoiceLabels: buildInvoiceLabels(invoice.partnerInvoices),
      })
    },
    [invoice, onRunAction],
  )

  return (
    <InvoiceActionsMenu
      verbs={verbs}
      dataTestId={`invoices-list-actions-${invoice.id}`}
      onSelect={handleSelect}
    />
  )
}

export const ComposedInvoiceActionsCell = memo(ComposedInvoiceActionsCellComponent)
